import React from 'react';
import urlBase from '../../url-base';
import {
    Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
import Sidebar from '../Sidebar/MenuLeft';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';


class Page extends React.Component {

   
    render() {
        return (
            <div>
                <MenuNew />
                <NavbarDrop />

                <Container  id="wallet_slip">
                    <div className="wallet_slip_img_inst">
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1>INSTITUCIONAL</h1>
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>
                    
                </Container>

                <Container  style={{ marginTop: -40 }}>
                    <Row style={{ marginRight: 0 }}>
                        <Col style={{ marginTop: 60, marginRight: 35 }} xs="12" sm="12" md="2" lg="2" xl="4">
                            <Sidebar/>
                        </Col>
                        <Col style={{ marginTop: 60, margiLeft:20 }} xs="12" sm="12" md="10" lg="10" xl="7">
                            <p className="text_footer">A DENTAL CENTER</p>
                            <div className="line_footer_gradient">{""}</div>
                            <p style={{ textAlign: 'justify', marginTop: 40, marginBottom: 40}}>
                                A Dental Center está presente no cuidado com o sorriso de mais de 50 mil pessoas do Estado da Paraíba.

                                    O(a) cliente Dental Center conta com mais de 480 clínicas e profissionais de odontologia que oferecem a qualidade e segurança.

                                    Mais que um plano odontológico. Agentes do bem-estar. Promotores do desenvolvimento local.
                            </p>

                            <p className="text_footer">NOSSA IDENTIDADE</p>
                            <div className="line_footer_gradient">{""}</div>

                            <Row style={{ marginTop:35}}>
                                <Col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <img style={{ marginLeft: -12,marginBottom:8}} src={urlBase.client + 'assets/images2/missao.png'} width="235" />
                                </Col>

                                <Col xs="12" sm="12" md="8" lg="8" xl="8">
                                    <p style={{ textAlign: 'justify'}}>
                                        Oferecer os melhores e mais inovadores Planos Odontológicos do Mercado, 
                                        com foco na Satisfação dos Clientes, Colaboradores, Parceiros e Investidores.
                                    </p>
                                </Col>
                            </Row>


                            <Row style={{ marginTop: 35 }}>
                                <Col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <img style={{ marginLeft: -12, marginBottom: 8 }} src={urlBase.client + 'assets/images2/visao.png'} width="235" />
                                </Col>

                                <Col xs="12" sm="12" md="8" lg="8" xl="8">
                                    <p style={{ textAlign: 'justify' }}>
                                        Ser Líder em Qualidade, Crescimento e Inovação, comprometidos com práticas
                                        sustentáveis de Governança Corporativa e Desenvolvimento Humano.
                                    </p>
                                </Col>
                            </Row>


                            <Row style={{ marginTop: 35 }}>
                                <Col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <img style={{ marginLeft: -12, marginBottom: 8 }} src={urlBase.client + 'assets/images2/valores.png'} width="235" />
                                </Col>

                                <Col xs="12" sm="12" md="8" lg="8" xl="8">
                                    <p style={{ textAlign: 'justify' }}>
                                        <div className='text_item'>Ser <b>PIONEIRO</b>, porque estamos sempre à frente em Inovação. </div>
                                        <div className='text_item'>Ser <b>EXTRAORDINÁRIO</b>, porque a excelência já não é mais um desafio.</div> 
                                        <div className='text_item'>Ter <b>INTEGRIDADE</b>, porque praticamos respeito e honestidade. </div>
                                        <div className='text_item'>Ter o <b>DESENVOLVIMENTO HUMANO</b> como base para o nosso crescimento contínuo. </div>
                                        <div className='text_item'>Agir para <b>PROPORCIONAR SATISFAÇÃO</b> total dos stakeholders. </div>
                                        <div className='text_item'>Agir com <b>FÉ</b>, pois Deus é o principal responsável por nosso sucesso  </div>
                                    </p>
                                </Col>
                            </Row>
                            
                        </Col>
                    </Row>
                </Container>

                <Footer />
            </div>

        );
    }
}
export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/Institucional/Page.js
 **/